import type { AppRoles } from '~/constants/user'
import useUser from '~/composables/useUser'
import { isUserGranted } from '~/utils/user'

export const isCurrentUserGrantedInApp = (minimumRole: AppRoles) => {
  const { claims } = useUser()
  return isUserGranted(claims.value?.appRole, minimumRole)
}
